import { z } from 'zod';
import { uuidSchema } from './common.schema.js';

// ── Formula Storage Type ─────────────────────────────────────────────────────
export const FormulaStorageTypeSchema = z.enum(['ROOM_TEMPERATURE', 'REFRIGERATOR']);
export type FormulaStorageType = z.infer<typeof FormulaStorageTypeSchema>;

export const InventoryLocationSchema = z.object({
  location_id: uuidSchema,
  hospital_id: uuidSchema,
  location_code: z.string().max(50),
  name: z.string().max(200),
  location_type: z.string().max(50),
  parent_location_id: uuidSchema.nullable(),
  is_active: z.boolean(),
});

export type InventoryLocation = z.infer<typeof InventoryLocationSchema>;

export const CreateInventoryLocationRequestSchema = z.object({
  hospital_id: uuidSchema,
  name: z.string().min(1, 'Name is required').max(200),
  location_type: FormulaStorageTypeSchema.optional(),
});
export type CreateInventoryLocationRequest = z.infer<typeof CreateInventoryLocationRequestSchema>;

export const CreateInventoryLocationResponseSchema = z.object({
  location_id: uuidSchema,
  hospital_id: uuidSchema,
  location_code: z.string(),
  name: z.string(),
  location_type: z.string(),
  parent_location_id: uuidSchema.nullable(),
  is_active: z.boolean(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});
export type CreateInventoryLocationResponse = z.infer<typeof CreateInventoryLocationResponseSchema>;

export const ActiveInventoryLocationSchema = z.object({
  location_id: uuidSchema,
  hospital_id: uuidSchema,
  location_code: z.string(),
  name: z.string(),
  location_type: z.string(),
  parent_location_id: uuidSchema.nullable(),
  is_active: z.literal(true),
});
export type ActiveInventoryLocation = z.infer<typeof ActiveInventoryLocationSchema>;

export const UpdateInventoryLocationStatusRequestSchema = z.object({
  is_active: z.boolean(),
});
export type UpdateInventoryLocationStatusRequest = z.infer<typeof UpdateInventoryLocationStatusRequestSchema>;

export const UpdateInventoryLocationStatusResponseSchema = z.object({
  location_id: uuidSchema,
  hospital_id: uuidSchema,
  location_code: z.string(),
  name: z.string(),
  location_type: z.string(),
  parent_location_id: uuidSchema.nullable(),
  is_active: z.boolean(),
  updated_at: z.string().datetime(),
});
export type UpdateInventoryLocationStatusResponse = z.infer<typeof UpdateInventoryLocationStatusResponseSchema>;
